var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"map",staticClass:"map"}),_vm._v(" "),_c('div',{ref:"infoWindow",staticClass:"info-window"},[[_vm._l((_vm.markers),function(item){return _vm._t("infowindow",null,{"item":item})})]],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-daee5afe","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/views/components/ui-maps/ui-maps.vue
// module id = 745
// module chunks = 0